// @mui/icons-material
import QuestionAnswer from '@mui/icons-material/QuestionAnswer';
import Settings from '@mui/icons-material/Settings';
import Email from '@mui/icons-material/Email';
import Work from '@mui/icons-material/Work';
import List from '@mui/icons-material/List';
import Group from '@mui/icons-material/Group';
import Help from '@mui/icons-material/Help';
import School from '@mui/icons-material/School';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PersonPin from '@mui/icons-material/PersonPin';
import Public from '@mui/icons-material/Public';
import Accessibility from '@mui/icons-material/Accessibility';

export const routes = [
  {
    user: true,
    path: '/modifier-profil',
    name: 'Modifier mon profil',
    icon: Settings,
  },
  {
    path: '/tableau-de-bord',
    name: 'Tableau de bord',
    icon: DashboardIcon,
  },
  {
    path: '/eleves',
    name: 'Élèves',
    icon: Group,
  },
  {
    path: '/professionnels',
    name: 'Professionnels',
    icon: Accessibility,
  },
  {
    path: '/entreprises',
    name: 'Entreprises',
    icon: Work,
  },
  {
    path: '/colleges',
    name: 'Profils collège',
    icon: School,
  },
  {
    path: '/rh',
    name: 'Ressources Humaines',
    icon: Public,
  },
  {
    path: '/offres',
    name: 'Offres',
    icon: List,
  },
  {
    path: '/candidatures',
    name: 'Candidatures',
    icon: PersonPin,
  },
  {
    path: '/messages',
    name: 'Messages',
    icon: Email,
  },
  {
    path: '/rep-liste',
    name: 'Liste Collèges Rep',
    icon: School,
  },
  {
    path: '/liste-colleges',
    name: 'Liste Collèges',
    icon: School,
  },
  {
    path: '/associations',
    name: 'Liste associations',
    icon: School,
  },
  {
    path: '/logs',
    name: 'Logs',
    icon: List,
  },
  {
    path: '/Faq',
    name: 'Faq',
    icon: Help,
  },
  {
    path: '/Quizz',
    name: 'Quizz',
    icon: QuestionAnswer,
  },
  {
    path: '/unusual-facts',
    name: 'Unusual facts',
    icon: School,
  },
  {
    path: '/Tutorials',
    name: 'Tutorial',
    icon: Help,
  },
  {
    path: '/Checklists',
    name: 'Checklists',
    icon: List,
  },
];
